import { render } from "./ConfigOption.vue?vue&type=template&id=49eb80e2"
import script from "./ConfigOption.vue?vue&type=script&lang=js"
export * from "./ConfigOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__